import { Upload } from 'tus-js-client';

export enum UploadStatus {
  PENDING = 'pending',
  SCHEDULED = 'scheduled',
  INPROGRESS = 'inprogress',
  SUCCESS = 'success',
  FAILED = 'failed',
  BLOCKED = 'blocked',
  ABORTED = 'aborted',
};

export type ModelUpload = {
  file?: File;
  name: string;
  section?: string;
  status: UploadStatus;
  error?: Error;
  uploadId?: string;
  upload?: Upload;
  forced?: boolean;
  canRetry?: boolean;
  fingerprint?: string;
  previousUploadSize?: number;
  previousUploadCreationTime?: string;
}